import { render, staticRenderFns } from "./UndeliveredAtomCallPopup.vue?vue&type=template&id=d13c2974&scoped=true&"
import script from "./UndeliveredAtomCallPopup.vue?vue&type=script&lang=js&"
export * from "./UndeliveredAtomCallPopup.vue?vue&type=script&lang=js&"
import style0 from "./UndeliveredAtomCallPopup.vue?vue&type=style&index=0&id=d13c2974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13c2974",
  null
  
)

export default component.exports